class FlipCard {
  start() {
    const flipCards = document.querySelectorAll('.container-flipcard .flipcard');
    flipCards.forEach((item) => {
      item.addEventListener('click', onFlip);
    });
  }
}

function onFlip(e) {
  if (e.currentTarget.classList.contains('flipped')) {
    e.currentTarget.classList.remove('flipped');
  } else {
    e.currentTarget.classList.add('flipped');
  }

  if (!e.currentTarget.classList.contains('return')) {
    e.currentTarget.classList.add('return');
  }
}

module.exports = FlipCard;
